import { Injectable } from '@angular/core';
import { Assure, Vehicule } from '../../shared/model';
import { HttpClient } from '@angular/common/http';
import { DatabaseConnection } from '../../shared/services/database-connection';

@Injectable({
  providedIn: 'root',
})
export class AssureService {

  end_url = 'assure'

  constructor(private http : HttpClient, private  dbConnection : DatabaseConnection){}

  getAll(){
    return this.http.get<Assure[]>(this.dbConnection.remoteApiConnection.value + this.end_url + '/create')
  }

  find(assure : string){
    return this.http.get<Assure[]>(this.dbConnection.remoteApiConnection.value + this.end_url + '?search='+assure)
  }

  get(Assure_id : string){
    return this.http.get<Assure>(this.dbConnection.remoteApiConnection.value + this.end_url + '/' + Assure_id)
  }

  create(data : any){
    return this.http.post<Assure>(this.dbConnection.remoteApiConnection.value + this.end_url, data)
  }

  update(data : any, id : string){
    return this.http.put<Assure>(this.dbConnection.remoteApiConnection.value + this.end_url + '/' + id, data)
  }

  delete(id : string){
    return this.http.delete(this.dbConnection.remoteApiConnection.value + this.end_url + '/' + id)
  }

  changeStatus(id : string){
    return this.http.get<Assure>(this.dbConnection.remoteApiConnection.value + this.end_url + '/' + id + '/edit')
  }

  vehiculesNoAssure(assure : string, vehicule : string){
    return this.http.get<Vehicule[]>(this.dbConnection.remoteApiConnection.value + 'vehicules-non-assure/' + assure+"?vehicule="+vehicule)
  }
}
